import { EditorHeaderView } from './EditorHeaderView';
import useThumbnail from '../../hooks/useThumbnail';
import React, { memo } from 'react';
import { theme, Flex } from 'antd';
import './EditorHeader.css';

const { useToken } = theme;

export const EditorHeader = memo(({ selectedFile, user, onChange, isEditable }) => {
  const { token } = useToken();
  const { meta_info } = selectedFile || { title: '', meta_info: {} };
  const emojiState = useThumbnail({ dfltValue: meta_info?.icon, onChange, itemType: 'icon' });
  const coverState = useThumbnail({ dfltValue: meta_info?.thumbnail, onChange, itemType: 'thumbnail' });

  return (
    <>
      <Flex vertical style={{ ...(!coverState?.cover && !emojiState.emoji && { marginBottom: token.marginXS }) }}>
        <EditorHeaderView
          workspaceId={selectedFile?.workspace_id}
          fileId={selectedFile?.id}
          isEditable={isEditable}
          values={meta_info}
          {...{ emojiState, coverState }}
        />
      </Flex>
    </>
  );
});

export default EditorHeader;
